import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/ic-arrow-back.svg'


const _hoisted_1 = {
  class: "page__header",
  style: {"margin-top":"0"}
}
const _hoisted_2 = { class: "page__header-title" }
const _hoisted_3 = {
  class: "page__text",
  style: {"color":"#000"}
}
const _hoisted_4 = {
  class: "page__controls",
  style: {"margin-top":"2rem"}
}
const _hoisted_5 = {
  class: "page__split",
  style: {"align-items":"initial","height":"310px"}
}
const _hoisted_6 = {
  class: "page__stats",
  style: {"margin":"0","padding-right":"5rem"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", null, "Наименование подрынка", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", null, "Юридическое наименование", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", null, "ИНН", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", null, "Телефон администрации", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", null, "Территория (м2)", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", null, "Кол-во сотрудников администрации рынка", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", null, "Кол-во арендаторов (сумма НП)", -1)
const _hoisted_14 = {
  key: 0,
  class: "btns-row"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Редактировать подрынок")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Редактировать рынок")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Удалить рынок")
const _hoisted_18 = { class: "markets-taxpayers" }
const _hoisted_19 = { class: "markets-taxpayers__inner" }
const _hoisted_20 = {
  class: "page__stats",
  style: {"margin":"0"}
}
const _hoisted_21 = {
  key: 0,
  class: "markets-taxpayers__message"
}
const _hoisted_22 = {
  key: 1,
  class: "markets-taxpayers__message"
}
const _hoisted_23 = { style: {"width":"100%"} }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { colspan: "3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "markets-taxpayers__header-row" }, [
      /*#__PURE__*/_createElementVNode("div", null, "Юридическое наименование"),
      /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"left"} }, "Торговое наименование"),
      /*#__PURE__*/_createElementVNode("div", { style: {"width":"18%"} }, "№ Торг. места")
    ])
  ])
], -1)
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { style: {"width":"46%"} }
const _hoisted_27 = { class: "markets-taxpayers__row" }
const _hoisted_28 = {
  class: "markets-taxpayers__row",
  style: {"text-align":"left","display":"inline"}
}
const _hoisted_29 = {
  class: "markets-taxpayers__row",
  style: {"text-align":"right","display":"inline"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiSelector = _resolveComponent("UiSelector")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_ViewportObserver = _resolveComponent("ViewportObserver")!
  const _component_ModalSubMarketEdit = _resolveComponent("ModalSubMarketEdit")!
  const _component_ModalMarketEdit = _resolveComponent("ModalMarketEdit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "page__header-back",
        src: _imports_0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/markets-and-malls/markets')))
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", null, "Рынок " + _toDisplayString(_ctx.marketInfo.data?.name || 'без названия'), 1),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.marketInfo.data?.address || 'без названия'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_UiSelector, {
        style: {"width":"35rem"},
        label: "Подрынок",
        placeholder: "Выберите",
        "use-search": false,
        options: _ctx.subMarkets.options,
        modelValue: _ctx.subMarkets.options.find((item) => item.id === _ctx.taxpayers?.filters.subMarket),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterToQuery({subMarket: $event?.value || null, prohod: null })))
      }, null, 8, ["options", "modelValue"]),
      _createVNode(_component_UiSelector, {
        style: {"width":"35rem"},
        label: "Проход",
        placeholder: "Выберите",
        "use-search": false,
        options: _ctx.passages.options,
        modelValue: _ctx.passages.options.find((item) => item.id === _ctx.taxpayers?.filters.prohod),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => {_ctx.filterToQuery({prohod: $event?.value || null });}),
        disabled: !_ctx.taxpayers?.filters.subMarket
      }, null, 8, ["options", "modelValue", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", {
          style: _normalizeStyle({display: _ctx.subMarketInfo ? 'initial' : 'none' })
        }, [
          _createElementVNode("tr", null, [
            _hoisted_7,
            _createElementVNode("td", null, _toDisplayString(_ctx.subMarketInfo?.name || 'Не задано'), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_8,
            _createElementVNode("td", null, _toDisplayString(_ctx.subMarketInfo?.legalName || 'Не задано'), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_9,
            _createElementVNode("td", null, _toDisplayString(_ctx.subMarketInfo?.inn || 'Не задан'), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_10,
            _createElementVNode("td", null, _toDisplayString(_ctx.subMarketInfo?.phone || 'Не задан'), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_11,
            _createElementVNode("td", null, _toDisplayString(_ctx.subMarketInfo?.area  || 'Не задана'), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_12,
            _createElementVNode("td", null, _toDisplayString(_ctx.subMarketInfo?.workersCount || 'Не задано'), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_13,
            _createElementVNode("td", null, _toDisplayString(_ctx.subMarketInfo?.taxpayersCount || 'Не задано'), 1)
          ])
        ], 4),
        (_ctx.isRoleCA !== true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (_ctx.subMarketInfo != null)
                ? (_openBlock(), _createBlock(_component_Btn, {
                    key: 0,
                    size: "small",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modalMarket.displaySubMarketEdit=true))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.marketInfo.data != null)
                ? (_openBlock(), _createBlock(_component_Btn, {
                    key: 1,
                    size: "small",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.modalMarket.displayMarketEdit=true))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.marketInfo.data != null)
                ? (_openBlock(), _createBlock(_component_Btn, {
                    key: 2,
                    class: "btn--primary",
                    size: "small",
                    onClick: _ctx.modalMarket.deleteMarket
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            (_ctx.taxpayers.fetching && !_ctx.taxpayers.rows.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, "Идет загрузка..."))
              : (!_ctx.taxpayers.fetching && !_ctx.taxpayers.rows.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, "Нет данных о налогоплательщиках"))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("table", _hoisted_23, [
                      _hoisted_24,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taxpayers.rows, (taxpayer) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          class: "link",
                          onClick: ($event: any) => (_ctx.$router.push(`${_ctx.$route.params.marketId}/${taxpayer.id}`)),
                          style: {"cursor":"pointer"}
                        }, [
                          _createElementVNode("td", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, _toDisplayString(taxpayer.legalName || 'Без имени'), 1)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_28, _toDisplayString(taxpayer.tradeNum || 'Без имени'), 1)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_29, _toDisplayString(taxpayer.placeNum || 'Нет'), 1)
                          ])
                        ], 8, _hoisted_25))
                      }), 256))
                    ]),
                    (_ctx.taxpayers.showLoader)
                      ? (_openBlock(), _createBlock(_component_ViewportObserver, {
                          key: 0,
                          onShow: _cache[5] || (_cache[5] = ($event: any) => (_ctx.taxpayers.fetchNextPage()))
                        }))
                      : _createCommentVNode("", true)
                  ], 64))
          ])
        ])
      ])
    ]),
    (_ctx.modalMarket.displaySubMarketEdit)
      ? (_openBlock(), _createBlock(_component_ModalSubMarketEdit, {
          key: 0,
          onClose: _ctx.handleCloseMarketModal,
          data: _ctx.subMarketInfo
        }, null, 8, ["onClose", "data"]))
      : _createCommentVNode("", true),
    (_ctx.modalMarket.displayMarketEdit)
      ? (_openBlock(), _createBlock(_component_ModalMarketEdit, {
          key: 1,
          onClose: _ctx.handleCloseMarketModal,
          data: _ctx.marketInfo.data
        }, null, 8, ["onClose", "data"]))
      : _createCommentVNode("", true)
  ], 64))
}